/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autoloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
import { Foundation } from './foundation';
Foundation.addToJquery(jQuery);

$(document).ready(function() {

    $(document).foundation();

    // Search input clear
    var searchField = $('#SearchForm_SearchForm_Search');
    if ($(searchField).val() == $(searchField).attr('placeholder')) {
        $(searchField).val('');
    }

    // Search change form action for Collections Online
    $('.search input').change(function() {

        var searchForm = $('#SearchForm_SearchForm');
        var searchValue = $(searchField).val();
        var searchRadio = $('.radio-collection:checked');

        if ($(searchRadio).val()) {
            $(searchField).attr('name', 'query');
            $(searchForm).prop('action', 'https://collection.canterburymuseum.com/' + $(searchRadio).val());
        }
    });

    // Fixed header on scroll
    var headerHeight = $('.header').innerHeight(),
        fixedNavOffset = $('.navigation').offset().top;

    if ($(window).width() >= 1024) {

        // On scroll
        $(window).scroll(function () {
            var header = $('.header'),
                scroll = $(window).scrollTop();

            if (scroll >= fixedNavOffset) {
                header.addClass('fixed');
                $('.content').css('paddingTop', headerHeight)
            }
            else {
                header.removeClass('fixed');
                $('.logo').addClass('fade-in');
                $('.content').css('paddingTop', '0')
            }
        });
    }

    // Search reveal
    $('.site-search-trigger').on('click', function(event) {
        event.preventDefault();
        $('.search').slideToggle(500, 'swing', function() {
            fixedNavOffset = $('.navigation').offset().top;
        });
    });

    // Mega Menu reveal
    var megaMenuVisible = false,
        $megaMenu;

    $('a.top-level').on('mouseenter', function() {
        $megaMenu = $('.mega-menu', $(this).parent('li'));
        if (megaMenuVisible && !$(this).hasClass('visible')) {
            $('.mega-menu.visible').fadeOut(300).removeClass('visible');
            $('.top-level.visible').removeClass('visible');
            megaMenuVisible = false;
        }
        if ($(this).hasClass('has-submenu')) {
            $(this).addClass('visible');
            $($megaMenu).fadeIn(300).addClass('visible');
            megaMenuVisible = true;
        }
    });

    $('.content, .footer-banner, .footer').on('mouseenter', function() {
        if (megaMenuVisible) {
            $('.mega-menu.visible').fadeOut(300).removeClass('visible');
            $('.top-level.visible').removeClass('visible');
            megaMenuVisible = false;
        }
    });

    // If Mega Menu is visible on scroll, hide it
    $(window).scroll(function () {
        if (megaMenuVisible) {
            $('.mega-menu.visible').fadeOut(300).removeClass('visible');
            $('.top-level.visible').removeClass('visible');
            megaMenuVisible = false;
        }
    });

    // For anchor links in Mega Menu, gives illusion of page refresh
    $('.anchor-link').on('click', function(event) {
        if (megaMenuVisible) {
            $('.mega-menu.visible').fadeOut(300).removeClass('visible');
            $('.top-level.visible').removeClass('visible');
            megaMenuVisible = false;
        }
    });

    // Gallery popup
    if($('.mfp-gallery-open').length) {
        $('.mfp-gallery-open').magnificPopup({
            mainClass: 'mfp-with-zoom',
            closeMarkup: '<a title="%title%" class="mfp-close mfp-close-text">Close window</a>',
            showCloseBtn: true,
            closeBtnInside: true,
            closeOnBgClick: true,
            gallery: {
                enabled: true,
                preload: [1,2]
            },
            image: {
                titleSrc: 'title'
            },
            ajax: {
              settings: {
                  cache: false,
                  async: true
              },
              cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
              tError: '<a href="%url%">The content</a> could not be loaded.' //  Error message, can contain %curr% and %total% tags if gallery is enabled
          },
          callbacks: {
            ajaxContentAdded: function() {
                // Ajax content is loaded and appended to DOM
                $('.magnific-close').on('click', function(event) {
                    event.preventDefault();
                    $.magnificPopup.close();
                });
                $(document).foundation();
            }
          }
        });
    }

    // Exhibition page functionality
    // Anchor scroll
    $('.anchor-scroll a').click(function(){
        $('html, body').animate({
            scrollTop: $(this.hash).offset().top - $('.header').outerHeight()
        }, 750);
        return false;
    });

    // Exhibition anchor menu active states
    $(".exhibition-section").each(function() {
        {
            var t = $(this)
                n = $(window).width() >= 640 ? $('.header').outerHeight(!1) + 50 : 0;

            // Down scroll
            new Waypoint({
                element: t,
                handler: function(direction) {
                    if (direction === 'down') {
                        $('.side-links li').removeClass('active');
                        $('.side-links').find('a[href*="#' + t.attr('id') + '"]').parent('li').addClass('active');
                    }
                },
                offset: n
            });

            // Up scroll
            new Waypoint({
                element: t,
                handler: function(direction) {
                    if (direction === 'up') {
                        $('.side-links li').removeClass('active');
                        $('.side-links').find('a[href*="#' + t.attr('id') + '"]').parent('li').addClass('active');
                    }
                },
                offset: 0
            });
        }
    });
    var listingsString;

    // Handle submission of subscribe form
    // $('#Form_CMForm').on("submit", function(e){
    //     e.preventDefault();
    //     e.stopPropagation();
    //
    //     var form = $(this),
    //         formData = $(this).serialize();
    //
    //     if ($('input[name*="EmailSubscription"]:checked').length > 0) {
    //         $.ajax({
    //             type: 'POST',
    //             url: form.attr('action'),
    //             dataType: 'jsonp',
    //             data: formData
    //         }).done(function (response) {
    //             var response = jQuery.parseJSON(response.responseText),
    //                 listings = [];
    //
    //             $.each(response, function( index, value ) {
    //                 if (value.result.http_status_code == '201') {
    //                     listings.push(value.label);
    //                 }
    //             });
    //
    //             if (listings.length > 0) {
    //                 form.animate({'opacity' : 0}, 500, function(){
    //                     listingsString = listings.join(', ').replace(/,(?=[^,]+$)/, ' and');
    //                     form.html('<div class="callout success"><p>Successfully signed up to ' + listingsString + '</p></div>').animate({'opacity' : 1}, 500);
    //                 });
    //             }
    //         });
    //     }
    //
    //     return false;
    // });

    // Magnific
    $('.mfp-open').magnificPopup({
        mainClass: 'mfp-with-zoom',
        closeMarkup: '<a title="%title%" class="mfp-close mfp-close-text">Close window</a>',
        showCloseBtn: true,
        closeBtnInside: true,
        closeOnBgClick: true,
        gallery: {
            enabled: true,
            preload: [1,2]
        },
        image: {
            titleSrc: 'title'
        },
        iframe: {
            patterns: {
                youtube: {
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
                }
            }
        },
        ajax: {
          settings: {
              cache: false,
              async: true
          },
          cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
          tError: '<a href="%url%">The content</a> could not be loaded.' //  Error message, can contain %curr% and %total% tags if gallery is enabled
      },
      callbacks: {
        ajaxContentAdded: function() {
            // Ajax content is loaded and appended to DOM
            $('.magnific-close').on('click', function(event) {
                event.preventDefault();
                $.magnificPopup.close();
            });
            $(document).foundation();
        }
      }
    });

    // Magnific
    $('.mfp-inline-open').magnificPopup({
        mainClass: 'mfp-with-zoom',
        closeMarkup: '<a title="%title%" class="mfp-close mfp-close-text">Close window</a>',
        showCloseBtn: true,
        closeBtnInside: true,
        closeOnBgClick: true,
        gallery: {
            enabled: false
        }
    });

    let EventRegistrationSubmit = document.querySelector('.EventRegistrationPage #Form_Form_action_submit');
    let EventRegistrationForm = document.querySelector('.EventRegistrationPage #Form_Form');
    if(EventRegistrationForm) {
        EventRegistrationForm.addEventListener('submit', function() {
            EventRegistrationSubmit.disabled = true
        })
    }

});



// WEBPACK FOOTER //
// ./javascript/app.js